export { default } from './TextComponent';
